import styled from 'styled-components';

export const StyledHeader = styled.nav`
    display: flex;
    height: 88px;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
        height: auto;
        margin: 10px 30px 20px 30px;
    }

    @media screen and (max-width: 500px) {
        margin: 10px 10px 24px 10px;
    }
`;

export const HeaderContent = styled.div`
    background: none;
    display: flex;
    width: 100%;
    align-items: center;
    margin: 1rem;
    justify-content: space-between;
    @media screen and (min-width: 1366px) {
        max-width: 84rem;
        flex: 1;
    }
`;

export const HeaderImg = styled.img`
    height: 53px;
    width: 172px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        height: 50px;
        width: 163px;
        margin: 0 auto;
    }

    @media screen and (max-width: 500px) {
        height: 29.38px;
        width: 95.71px;
    }
`;
export const HeaderIcons = styled.div`
    display: flex;
    flex-direction: row;
    img {
        margin-right: 8px;
        width: 28px;
        height: 28px;
        cursor: pointer;
    }

    label {
        font-size: 16px;
        line-height: 19px;
        color: ${({ theme }) => theme.colors.blue};
        cursor: pointer;
        font-family: ${({ theme }) => theme.font.defaults.fontFamily};
    }
    @media (max-width: 500px) {
        label {
            display: none;
        }
    }
`;

export const IconWrapper = styled.div`
    position: relative;
    &:first-child {
        padding-right: 2rem;
    }
`;
export const MenuWrapper = styled.div`
    gap: 41px;
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        display: none;
    }
`;
export const RoundIconWrapper = styled.div`
    position: relative;
    display: flex;
    cursor: pointer;
    color: #fff;
    height: 47px;
    width: 47px;
    background-color: #0a4a8d;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0;
    border-radius: 48px;
    line-height: 21px;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 769px) {
        color: #0a4a8d;
        background-color: #fff;
    }
`;

export const NavigationIcons = styled.div`
    color: #214781;
    font-size: 21px;
    letter-spacing: 0;
    line-height: 24px;
    cursor: pointer;
`;

export const ExtraDiv = styled.div`
    @media screen and (min-width: 769px) {
        display: none;
    }
`;
